
import React from 'react';
import { Button } from '@/components/ui/button';
import { useAuthTabSwitcher } from '@/hooks/useAuthTabSwitcher';
import { Sparkles } from 'lucide-react';
import { useSignupForm } from './signup/useSignupForm';
import FormFields from './signup/FormFields';
import SuccessMessage from './signup/SuccessMessage';
import { BrandAlert } from '@/components/ui/brand';

const SignupForm = () => {
  const { switchTab } = useAuthTabSwitcher();
  const {
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    fullName,
    setFullName,
    loading,
    resendLoading,
    error,
    isThrottled,
    signupSuccess,
    handleSignUp,
    handleResendEmail
  } = useSignupForm();

  if (signupSuccess) {
    return (
      <SuccessMessage
        handleResendEmail={handleResendEmail}
        resendLoading={resendLoading}
        switchToSignIn={() => switchTab('signin')}
      />
    );
  }

  return (
    <form onSubmit={handleSignUp} className="space-y-4">
      {error && (
        <BrandAlert type="error" title="Let's fix this together">
          {error}
        </BrandAlert>
      )}
      
      <FormFields
        fullName={fullName}
        setFullName={setFullName}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        loading={loading}
        isThrottled={isThrottled}
      />

      <Button 
        type="submit" 
        className="w-full bg-brand text-white rounded-xl font-semibold gap-2" 
        disabled={loading || isThrottled}
      >
        {loading ? "Creating account..." : isThrottled ? "Try again in 30 seconds" : "Get Started"}
        {!loading && !isThrottled && <Sparkles className="h-4 w-4" />}
      </Button>
      
      <div className="text-center text-sm mt-4 pb-2">
        <span className="text-muted-foreground">Already have an account?</span>{" "}
        <button 
          type="button"
          onClick={() => switchTab('signin')}
          className="text-brand hover:underline bg-transparent border-none p-0 cursor-pointer font-medium"
          disabled={loading}
        >
          Sign in instead
        </button>
      </div>
    </form>
  );
};

export default SignupForm;
